import React from 'react'
import Evaluate from 'src/modules/EEvaluation/Evaluate'

const EvaluatePage = () => {
  return <Evaluate />
}
export default EvaluatePage
